module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-success"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap success-msg col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("報名成功")]), _c('div', {
    staticClass: "content border-styled"
  }, [_c('span', [_vm._v("您的報名資訊已成功送出，我們將在 2017/10/31 前審核您的報名資料審核後資訊無誤將會通知您付款資訊。\n您可以至「")]), _c('router-link', {
    staticClass: "link-red",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_vm._v("查看票卷")]), _c('span', [_vm._v("」取得您的報名進度與付款資訊。")])], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap info-schedule col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("訂單資訊")]), _c('div', {
    staticClass: "content border-styled"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), (_vm.getUser.registered.me) ? _c('span', [_vm._v(_vm._s(_vm.getUser.registered.me.status_string))]) : _vm._e(), (_vm.getUser.registered.me && _vm.getUser.registered.me.status !== 1 && _vm.getUser.registered.me.status !== 5) ? _c('div', [(_vm.getUser.payment.payments_code) ? _c('hr') : _vm._e(), (_vm.getUser.payment.payments_code) ? _c('ul', {
    staticClass: "payment-code"
  }, [_c('li', [_vm._v("繳費代碼")]), _c('li', [_vm._v(_vm._s(_vm.getUser.payment.payments_code))])]) : _vm._e(), _c('hr'), _c('ul', {
    staticClass: "payment-detail"
  }, [_c('li', [_c('span', [_vm._v("商品名稱")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.description))])]), _c('li', [_c('span', [_vm._v("訂單編號")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.order_id))])]), _c('li', [_c('span', [_vm._v("金額")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.amount))])]), (_vm.getUser.payment.expired_at) ? _c('li', [_c('span', [_vm._v("繳費期限")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.expired_at))])]) : _vm._e()])]) : _vm._e()])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap col-md-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("報名資訊")]), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getUser.registered.group), function(register) {
    return (_vm.getUser.registered.group) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "apply-info",
      class: {
        'isLeader': register.is_leader === true, 'isMe': register.is_me
      }
    }, [_c('div', {
      staticClass: "content border-styled ltr-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _c('ul', {
      staticClass: "text col-md-7"
    }, [_c('li', [_vm._v(_vm._s(register.nickname))]), _c('li', [_vm._v(_vm._s(register.gamers_account))]), _c('li', [_vm._v(_vm._s(register.id_number))]), _c('li', [_vm._v(_vm._s(register.email))])])])])])]) : _vm._e()
  }))])]), _c('hr'), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn ghost-btn next-btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'homepage'
        })
      }
    }
  }, [_vm._v("回首頁")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "title col-md-5"
  }, [_c('li', [_vm._v("暱稱")]), _c('li', [_vm._v("帳號")]), _c('li', [_vm._v("身分證末四碼")]), _c('li', [_vm._v("Email")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab326b7a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/ticketSuccess.vue
// module id = 579
// module chunks = 1